"use strict";
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      updateCartData();
    }, 5000);
  });

  const updateCartData = async () => {
    console.log("UPDATE CART DATA -----------");
    try {
      const response = await fetch(`/cart?section_id=main-cart`);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, "text/html");

      updateData(html);
    } catch (error) {
      console.error("Error initial updating:", error);
    }
  };

  const updateData = (html) => {
    if (!html) return;

    const subtotalContainer = document.querySelector(
      "[data-subtotal-container]",
    );
    const newSubtotalContainer = html.querySelector(
      "[data-subtotal-container]",
    );
    const savings = document.querySelector("[data-savings]");
    const newSavings = html.querySelector("[data-savings]");
    const dueCard = document.querySelector("[data-due-card]");
    const newDueCard = html.querySelector("[data-due-card]");

    if (subtotalContainer && newSubtotalContainer) {
      subtotalContainer.innerHTML = newSubtotalContainer.innerHTML;
    }

    if (savings && newSavings) {
      savings.innerHTML = newSavings.innerHTML;
    }

    if (dueCard && newDueCard) {
      dueCard.innerHTML = newDueCard.innerHTML;
    }

    updateCartItems(html);
  };

  const updateCartItems = (html) => {
    if (!html) return;
    const cartItems = document.querySelectorAll("[data-cart-product]");
    const newCartItems = html.querySelectorAll("[data-cart-product]");

    if (!cartItems || cartItems?.length == 0) return;
    cartItems.forEach((item, ind) => {
      const newItem = newCartItems[ind];
      if (!newItem) return;

      const info = item.querySelector(".cart__item--name");
      const newInfo = newItem.querySelector(".cart__item--name");

      if (!info || !newInfo) return;

      info.innerHTML = newInfo.innerHTML;
    });
  };
})();
